export const GET_TRAINING_ANALYSIS_REPORT =
  'src/modules/trainingsAnalsisReport/GET_TRAINING_ANALYSIS_REPORT';
export const DOWNLOAD_REPORT =
  'src/modules/trainingsAnalsisReport/DOWNLOAD_REPORT';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/trainingsAnalsisReport/CANCEL_ALL_API_REQUESTS';


